<template lang="pug">

  v-card(class="pa-4")
    div(v-show="showSimpleLoading")
      SimpleLoading

    v-list(avatar)
      v-subheader {{ $t('usersOnlineList.TITLE') }}
      v-dialog(v-model="dialog" width="600")
      v-list-item-group(v-if="items.length > 0")
        template(v-for="(item, index) in items")
          v-list-item(:key="item.index" @click="showDialog(`${item._id}`)")
            template(v-slot:default="{ active, toggle }")
              v-list-item-avatar
                v-icon(v-show="item.os == 'Android'") mdi-android
                v-icon(v-show="item.os == 'iOS'") mdi-apple
                v-icon(v-show="item.os == 'Windows'") mdi-laptop
                v-icon(v-show="item.os == undefined") mdi-cellphone
              v-list-item-content
                v-list-item-title(v-html="item.nome")

          v-divider(v-if="index + 1 < items.length" :key="index")

        v-card <!-- ------- added for dialog -->
          ClientProfile <!-- ------- added for dialog -->

      v-list-item-group(v-else color="primary")
        v-list-item
          v-list-item-avatar
            v-icon mdi-account-alert
          v-list-item-content
            v-list-item-title(class="display-0 font-weight-bold grey--text") {{ this.$t('usersOnlineList.EMPTY') }}

      //h4(v-else class="caption text-center") {{ this.$t('usersOnlineList.EMPTY') }}

    //v-divider
    div(class="text-center")
      v-btn(id="showAll" x-small icon dark elevation="2" color="#c0c0c0" v-on:click="showAll" v-show="btShowing && onlineUsers.length > registersToShow")
        v-icon(dark) mdi-plus
      v-btn(id="showLess" x-small icon dark elevation="2" color="#c0c0c0" v-on:click="showLess" v-show="!btShowing && items.length > registersToShow")
        v-icon mdi-minus

      //v-btn(id="showAll" text small v-on:click="showAll" v-show="btShowing && onlineUsers.length > registersToShow") {{ this.$t('usersOnlineList.SHOWALLBT') }}
      //v-btn(id="showLess" text small v-on:click="showLess" v-show="!btShowing && items.length > registersToShow") {{ this.$t('usersOnlineList.SHOWLESSBT') }} */

    v-dialog(v-model="dialog" width="500" ref="modal")
      template(v-slot:activator="{ on }")

      v-card
        ClientProfile(:clientItem='clientItem')

        v-card-actions
          v-col(cols="12")
            v-btn(text class="blue--text" v-on:click="dialog=false") FECHAR
</template>

<script>
import { mapActions } from 'vuex'
import SimpleLoading from '@/components/core/SimpleLoading.vue'
import ClientProfile from '@/components/clients/ClientProfile.vue'

export default {
  name: 'UsersOnlineList',
  data: function () {
    return {
      dialog: false,
      clientId: '',
      clientItem: [],
      showSimpleLoading: false,
      btShowing: true,
      registersToShow: 5,
      item: 5,
      items: [{}],
    };
  },
  components: {
    SimpleLoading,
    ClientProfile
  },
  created () {
    this.getOnlineUsersFromHS()
  },
  computed:{
    selectedHs () {
      return this.$store.state.adminHotspots.selectedHotspot
    },
    onlineUsers() {
      return this.$store.state.adminDash.onlineUsers
    }
  },
  methods: {
    ...mapActions(['getOnlineUsers', 'getClientProfile']),

    async showDialog(id){
      this.showSimpleLoading = true
      await this.getClientProfile({
        _id: id
      })
      this.clientItem = this.$store.state.adminClients.client
      this.dialog=true
      this.showSimpleLoading = false
    },

    async getOnlineUsersFromHS(){
      if(window.localStorage.getItem('selectedHotspot') != null){
        this.showSimpleLoading = true
        await this.getOnlineUsers({
          identity: window.localStorage.getItem('selectedHotspot').split('"').join('')
        })
      }

      this.items = this.onlineUsers.slice(0, this.registersToShow)
      this.showSimpleLoading = false
    },

    showAll: function () {
        this.items = this.onlineUsers
        this.btShowing = false;
      },
    showLess: function () {
        this.items = this.items.slice(0, this.registersToShow);
        this.btShowing = true;
      }
    },

    watch: {
      selectedHs () {
        this.getOnlineUsersFromHS()
      }
    }
}
</script>
